<div
    class="dashboard-card dashboard-card-padding"
    style="display: flex; flex-direction: column; height: 100%"
>
    <div class="dashboard-card-header">
        <div style="display: flex; align-items: center; gap: 5px">
            <div *ngIf="canShowCardTitle()" class="dashboard-card-title">
                {{ getCardTitle() }}
            </div>
            <span
                *ngIf="dashboardItem.chartDocumentation"
                class="chart-documentation"
                nz-icon
                nzType="info-circle"
                nzTheme="outline"
                (click)="showChartDocumentation()"
            ></span>

            <button
                *ngIf="showErrorIcon"
                nz-button
                nz-tooltip
                [nzTooltipTitle]="dataLoaderResult.statusMessage"
                (click)="copyStatusMessage()"
                z-index="100"
            >
                <span nz-icon nzType="warning" nzTheme="outline"></span>
            </button>
            <div *ngIf="canShowCardSubTitle()" class="dashboard-card-subtitle">
                {{ dashboardItem.subtitle }}
            </div>
        </div>
        <div class="dashboard-card-header-actions">
            <ng-content select="[table-header-actions]"></ng-content>
            <button
                nz-button
                nz-dropdown
                [nzDropdownMenu]="menu"
                nzPlacement="bottomRight"
            >
                <span nz-icon nzType="ellipsis"></span>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                    <li
                        *ngIf="canShowExportDataToCSV()"
                        nz-menu-item
                        (click)="exportVisibleDataToCSV()"
                    >
                        <span nz-icon nzType="download" nzTheme="outline"></span
                        >Export to csv
                    </li>
                    <li
                        *ngIf="canShowExportDataToXLSX()"
                        nz-menu-item
                        (click)="exportVisibleDataToXLSX()"
                    >
                        <span
                            nz-icon
                            nzType="file-excel"
                            nzTheme="outline"
                        ></span
                        >Export to Excel
                    </li>
                </ul>
            </nz-dropdown-menu>
        </div>
    </div>
    <div class="fill-me" style="height: 100%">
        <div *ngIf="showErrorOverlay" class="table-overlay">
            <div class="error-container">
                <h2 class="error-title">{{ errorTitle }}</h2>
                <p class="error-message">{{ errorMessage }}</p>
            </div>
        </div>
        <div #tableContainer style="height: 100%">
            <nz-table
                #table
                [nzData]="listOfData"
                [nzLoading]="isLoading"
                [nzFrontPagination]="dashboardItem.viewMode !== 'scroll'"
                [nzShowPagination]="dashboardItem.viewMode !== 'scroll'"
                [nzPageSize]="
                    dashboardItem.viewMode !== 'scroll'
                        ? (dashboardItem.nzPageSize ?? 35)
                        : 0
                "
                [nzScroll]="
                    dashboardItem.viewMode !== 'scroll'
                        ? { x: '100%' }
                        : { x: '100%', y: tableScrollY }
                "
                [nzHideOnSinglePage]="true"
            >
                <thead>
                    <tr>
                        <ng-container
                            *ngFor="let column of tableOptions.columns"
                        >
                            <ng-container
                                *ngIf="column.listOfFilter; else noFilter"
                            >
                                <th
                                    [nzLeft]="column.nzLeft"
                                    [nzAlign]="column.nzAlign ?? 'left'"
                                    [nzWidth]="column.nzWidth ?? null"
                                    [nzSortOrder]="null"
                                    [nzSortPriority]="1"
                                    [nzSortFn]="getColumnSortFn(column)"
                                    [nzSortDirections]="[
                                        'ascend',
                                        'descend',
                                        null,
                                    ]"
                                    [nzFilters]="column.listOfFilter"
                                    [nzFilterMultiple]="true"
                                    [nzFilterFn]="column.nzFilterFn ?? null"
                                >
                                    {{ column.name }}
                                </th>
                            </ng-container>
                            <ng-template #noFilter>
                                <th
                                    [nzLeft]="column.nzLeft"
                                    [nzAlign]="column.nzAlign ?? 'left'"
                                    [nzWidth]="column.nzWidth ?? null"
                                    [nzSortOrder]="null"
                                    [nzSortPriority]="1"
                                    [nzSortFn]="getColumnSortFn(column)"
                                    [nzSortDirections]="[
                                        'ascend',
                                        'descend',
                                        null,
                                    ]"
                                    [nzFilterMultiple]="true"
                                    [nzFilterFn]="null"
                                >
                                    {{ column.name }}
                                </th>
                            </ng-template>
                        </ng-container>
                    </tr>
                </thead>
                <tbody>
                    <!-- <ng-template nz-virtual-scroll let-data let-index="index"> -->
                    <tr
                        *ngFor="let data of table.data"
                        [class.row-clickable]="rowClick.observed"
                        [class.row-muted]="data.muted"
                        (click)="rowClick.emit(data)"
                    >
                        <!-- <tr> -->
                        <td
                            *ngFor="let column of tableOptions.columns"
                            [style.background]="
                                data?.data?.[column.id]?.['background-color'] ??
                                ''
                            "
                            [style.padding-left.px]="treeIndent(data, column)"
                            [nzLeft]="column.nzLeft"
                            [nzAlign]="column.nzAlign ?? 'left'"
                        >
                            <span
                                *ngIf="isTreeColumn(column)"
                                class="tree-caret"
                                [class.tree-caret-hidden]="!data.expandable"
                                (click)="
                                    toggleExpand(data); $event.stopPropagation()
                                "
                                >{{ treeCaret(data) }}</span
                            >
                            {{ data?.data?.[column.id]?.label }}
                        </td>
                    </tr>
                    <!-- </ng-template> -->
                </tbody>
            </nz-table>
        </div>
    </div>
</div>
